import React from 'react';
import { useRightPanel } from './RightPanelContext';

interface RightPanelProps {
  className?: string;
}

/**
 * Fixed-position panel container. Renders whatever content is pushed into it via
 * useRightPanelControl — content components own their own chrome (header, scroll,
 * footer) by wrapping themselves in RightPanelShell or managing layout freely.
 */
const RightPanel: React.FC<RightPanelProps> = ({ className = '' }) => {
  const { isOpen, content, panelWidth } = useRightPanel();

  if (!isOpen) {
    return null;
  }

  return (
    <div
      className={`fixed top-0 right-0 h-full bg-white border-l border-gray-200 shadow-lg z-[1001] flex flex-col ${className}`}
      style={{ width: panelWidth }}
    >
      {content}
    </div>
  );
};

export default RightPanel;
